import { CHAINS_CONFIG_BY_SLUG } from '#lib/constants/chainsConfig.js'
import { getPageMetaTags } from '#lib/utils/seo.js'

import type { PageLoad } from './$types'

export const load = (async ({ params }) => {
	const [leftSlug, rightSlug] = params.slug.split('-vs-')
	const [left, right] = [CHAINS_CONFIG_BY_SLUG[leftSlug], CHAINS_CONFIG_BY_SLUG[rightSlug]]
	const ordererSlug = [leftSlug, rightSlug].sort((a, b) => a.localeCompare(b)).join('-vs-')

	const pageTags = getPageMetaTags({
		title: `${left.name} vs ${right.name} [TPS, Max TPS, Block Time] | Chainspect`,
		description: `Compare ${left.name} vs ${right.name} by TPS, Max TPS, Block Time, TTF & Governance Model on Chainspect. Quickly identify the best and see how big the gap is.`,
		canonical: `https://chainspect.app/compare/${ordererSlug}`,
		image: `https://chainspect.app/compare/${params.slug}/og`,
	})

	return { ...pageTags }
}) satisfies PageLoad
